"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  'Add "{inputValue}"': ['Aggiungi "', ["inputValue"], '"'],
  "All items have been removed.": "Tutti gli elementi sono stati eliminati.",
  "Clear selection": "Cancella selezione",
  "No results found.": "Nessun risultato trovato.",
  "Press Enter to select or deselect an option.": "Premi Invio per selezionare o deselezionare un'opzione.",
  "Select All": "Seleziona tutto",
  "Selected Items": "Elementi selezionati",
  "Toggle menu": "Attiva/disattiva menu",
  "listbox contents": "contenuti casella di riepilogo",
  "{itemAsString} has been removed.": [["itemAsString"], " è stato rimosso."],
  "{itemAsString} has been selected.": [["itemAsString"], " è stato selezionato."],
  "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.": [["resultCount", "plural", {
    one: ["#", " risultato è"],
    other: ["#", " risultati sono"]
  }], " disponibili, utilizza i tasti freccia su e giù per navigare. Premi il tasto Invio per selezionare."],
  "{selectedValue} selected": [["selectedValue"], " selezionato"],
  "{totalSelectedItems} selected": [["totalSelectedItems"], " selezionati"],
  "{totalSelectedItems} selected. Deselect all": [["totalSelectedItems"], " selezionati. Deseleziona tutto"],
  "{totalSelectedItems} selected. Select all {totalOptions} items": [["totalSelectedItems"], " selezionati. Seleziona tutti gli elementi ", ["totalOptions"]]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map